import React, { useState, useEffect } from "react";
import { Form, Input, Space, Button, Spin } from "antd";
import TransferIdReadOnly from "./transfer-id-read-only";
import { updateTransferIdDetails } from "../../../../services/update-transfer-id-details";
import "./transferIdCreateEdit.css";
import DeliverablesTable from "../Deliverables/deliverables-table";
import { useParams, useNavigate } from "react-router-dom";

const TransferIdCreateEdit: React.FC = () => {
  const [editPage, setEditPage] = useState(true);
  const [initValues, setInitValues] = useState<any>(null);
  const [deliverablesData, setDeliverablesData] = useState<any>([]);
  const [values, setValues] = useState(null);
  const [isEditable, setIsEditable] = useState<boolean>(true);
  const [form] = Form.useForm();
  const formValues = Form.useWatch([], form);
  const { TextArea } = Input;
  const { id } = useParams();
  const navigate = useNavigate();
  const createFlow = !id;

  useEffect(() => {
    if (id) {
      updateTransferIdDetails({ number: id }).then((result) => {
        setInitValues({
          number: result.data.number,
          name: result.data.name,
          description: result.data.description,
          files: result.data.deliverables,
        });
      });
    }
  }, [id]);

  useEffect(() => {
      window.scrollTo(0, 0);
    }, [editPage]);

  useEffect(() => {
    if (initValues?.files && isEditable) {
      setValues({ ...formValues, deliverables: initValues.files });
      form.setFieldsValue({ deliverables: initValues.files });
    } else {
      setValues({ ...formValues, deliverables: deliverablesData });
      form.setFieldsValue({ deliverables: deliverablesData });
    }
    // eslint-disable-next-line
  }, [initValues, isEditable, deliverablesData]);

  const handleNext = () => {
    form
      .validateFields()
      .then(() => {
        setEditPage(false);
      })
      .catch((error) => {
        return;
      });
  };

  const handleCancel = () => {
    navigate("/admin/transfer-ids");
  };

  const handleEdit = () => {
    setEditPage(true);
  };

  if (initValues === null && id) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "70vh" }}>
        <Spin style={{ color: "green" }} />
      </div>
    );
  }

  const handleDeliverables = (data: any) => {
    setIsEditable(false);
    setDeliverablesData(data);
    setValues({ ...formValues, deliverables: data });
    form.setFieldsValue({ deliverables: data });
  };

  return (
    <>
      {editPage ? (
        <>
          <div
            style={{
              backgroundColor: "white",
              margin: "1rem 10rem",
              padding: "20px",
            }}
          >
            <Form layout="vertical" form={form} initialValues={initValues}>
              <span style={{ fontSize: "20px" }}>
                {" "}
                {`${!createFlow ? "Edit Transfer ID" : "Create New Transfer ID"}`}{" "}
              </span>
              <Form.Item
                label="Number"
                name="number"
                style={{ width: "50%", marginTop: "20px" }}
                required={false}
                rules={[
                  { required: true, message: "This is a required field" },
                  { pattern: /^\d+$/, message: 'Only numbers are allowed' },
                ]}
              >
                <Input disabled={!createFlow} />
              </Form.Item>
              <Form.Item
                label="Name"
                name="name"
                required={false}
                rules={[
                  { required: true, message: "This is a required field" },
                ]}
              >
                <Input disabled={!createFlow} />
              </Form.Item>
              <Form.Item
                label="Description"
                name="description"
                required={false}
                rules={[
                  { required: true, message: "This is a required field" },
                ]}
              >
                <TextArea rows={2} autoSize={{ minRows: 2 }} disabled={!createFlow} />
              </Form.Item>
              <Form.Item
                label="Deliverables"
                name="deliverables"
                required={false}
                rules={[
                  { required: true, message: "This is a required field" },
                ]}
              >
                <DeliverablesTable
                  deliverablesData={values}
                  handleDeliverables={handleDeliverables}
                />
              </Form.Item>
            </Form>
          </div>
          <div
            style={{
              backgroundColor: "white",
              margin: "1rem 10rem",
              padding: "20px",
            }}
          >
            <Space>
              <Button className="button" onClick={handleNext}>
                Next
              </Button>
              <Button onClick={handleCancel}>
                Cancel
              </Button>
            </Space>
          </div>
        </>
      ) : (
        <TransferIdReadOnly
          handleEdit={handleEdit}
          values={formValues}
          createFlow={createFlow}
        />
      )}
    </>
  );
};

export default TransferIdCreateEdit;
